import { render } from "./BaseSideBar.vue?vue&type=template&id=f2373d1a&scoped=true"
import script from "./BaseSideBar.vue?vue&type=script&lang=js"
export * from "./BaseSideBar.vue?vue&type=script&lang=js"

import "./BaseSideBar.vue?vue&type=style&index=0&id=f2373d1a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2373d1a"]])

export default __exports__